module.exports = __webpack_public_path__ + "img/carta-tinaba-orange.eee24ece.png";